/** App + auth headers/fields that may appear on Axios errors sent to Rollbar. */
const ROLLBAR_SCRUB_FIELD_NAMES = [
  'authorization',
  'cookie',
  'set-cookie',
  'password',
  'passwd',
  'pass',
  'pw',
  'secret',
  'secret_key',
  'access_token',
  'refresh_token',
  'token',
  'oauth_token',
  'api_key',
  'x-api-key',
  'csrf-token',
  'csrf_token',
  'x-csrf-token',
  'xsrf-token',
  'x-xsrf-token',
  '_token',
  'cf-turnstile-invisible-token',
  'cf-turnstile-managed-token',
  'x-g-recaptcha-response',
  'x-g-recaptcha-checkbox-response',
  'g-recaptcha-v3-response',
];

/** Rollbar SDK options: scrubFields redacts matching keys anywhere in the payload. */
// eslint-disable-next-line import/prefer-default-export
export function rollbarScrubOptions() {
  return {
    overwriteScrubFields: false,
    scrubFields: ROLLBAR_SCRUB_FIELD_NAMES,
  };
}
